module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Penyesuaian Nota Transaksi ")]), _vm._v(" "), _c('Form', {
    ref: "formNT",
    attrs: {
      "label-width": 120,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Type",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Pilih Kategori Bank"
    },
    on: {
      "on-change": function($event) {
        return _vm.checkValidation()
      }
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.value) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Akun Bank",
      "prop": "bankAccountId"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": function($event) {
        return _vm.checkValidation()
      }
    },
    model: {
      value: (_vm.bankAccountId),
      callback: function($$v) {
        _vm.bankAccountId = $$v
      },
      expression: "bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nomor NT Lama",
      "prop": "noteCode"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "placeholder": "Nomor Giro Lama"
    },
    on: {
      "on-change": function($event) {
        return _vm.checkForm()
      }
    },
    model: {
      value: (_vm.formNT.noteCode),
      callback: function($$v) {
        _vm.$set(_vm.formNT, "noteCode", $$v)
      },
      expression: "formNT.noteCode"
    }
  }, _vm._l((_vm.listNT), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.noteCode
      }
    }, [_vm._v("\n                    " + _vm._s(option.noteCode))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nomor NT Baru",
      "prop": "noteCodeOld"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "placeholder": "Nomor Giro Baru"
    },
    on: {
      "on-change": function($event) {
        return _vm.checkForm()
      }
    },
    model: {
      value: (_vm.formNT.noteCodeOld),
      callback: function($$v) {
        _vm.$set(_vm.formNT, "noteCodeOld", $$v)
      },
      expression: "formNT.noteCodeOld"
    }
  }, _vm._l((_vm.listNT), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.noteCode
      }
    }, [_vm._v("\n                    " + _vm._s(option.noteCode))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReady),
      expression: "isReady"
    }],
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formNT')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1196829a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/AdjustmentNoteCode.vue
// module id = 1778
// module chunks = 1